
import {NoticeProps } from "@/scripts/datatypes"
import {ClassData, PostStatus } from "../../common-datatypes";
import { Component,Mixins } from "vue-property-decorator";
import { ValidationObserver,ValidationProvider } from 'vee-validate'
import Common from '@/mixins/common'
import {doc,getDoc} from 'firebase/firestore'
import ModalSelectUser from '@/components/ModalSelectUser.vue'
import { ValidationFlags } from "vee-validate/dist/types/types"
import TemplateMembers from '@/components/TemplateMembers.vue'

@Component({
  components: {
    ModalSelectUser,
    TemplateMembers
  }
})

export default class EditClass extends Mixins(Common) {
  notice = {} as NoticeProps
  disabledEditClass = true
  defaultClassData: ClassData = {
    teacherUserIds: [],
    studentUserIds: [],
    name: '',
    description: '',
    memberUserIds: [],
    disabled: false,
    deleted: false,
    memberMeta: {},
    postStatus: 'draft'
  }
  tIsShow = false
  sIsShow = false
  theClassName = ''
  theClass = {...this.defaultClassData}
  initClassData = {...this.defaultClassData}
  isLoading = false

  get existClass(){
    return !! this.theClass.creationTime
  }

  get theClassId(){
    return this.$route.params.classId || ''
  }

  get memberUserIds(){
    return Array.from(new Set([...this.theClass.teacherUserIds,...this.theClass.studentUserIds]))
  }

  $refs!: {
    teachers: InstanceType<typeof ValidationProvider>;
    students: InstanceType<typeof ValidationProvider>;
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  get theClassDoc(){
    return doc(this.$getClassesColRef(),this.theClassId)
  }

  async editClass(){
		try{
			this.notice = {
				isShow: false,
			}
		
      if(await this.$refs.validationObserver.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        
        const data: ClassData = {
          ...this.theClass,
          memberUserIds: this.memberUserIds
        }

        await this.$updateDoc(this.theClassDoc,data)
        
        this.notice = {
          message: this.$t('editClass.success') as string,
          isShow: true,
          duration: 0,
          type: {'is-success': true}
        }
        
        this.theClassName = this.theClass.name || ''

        this.$nextTick(() => {
          this.$refs.validationObserver.reset()
        })
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('editClass.error') as string
      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
			
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  postStatuses(){
    if(this.$te('event.postStatus')){
      return this.$t('event.postStatus') as unknown as PostStatus
    }
    return undefined
  }

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
    try{
      try{
        const theClassDocData = await getDoc(this.theClassDoc)
        if(theClassDocData.exists()){
          this.theClass = {...this.theClass,...theClassDocData.data()}
          this.initClassData = {...this.theClass}
        }

        if(! this.existClass){
          throw Error()
        }
      }catch(error){
        this.notice = {
          message: this.$t('editClass.noClassFound') as string,
          isShow: true,
          duration: 0,
          type: {'is-danger': true}
        }
      }
      this.theClassName = this.theClass.name || ''
      

    }catch(error){
      console.table(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  updated(){
    if(! this.unwatch && this.$refs.validationObserver){
      this.unwatch = this.$watch('$refs.validationObserver.flags',(flags: ValidationFlags) => {
        this.disabledEditClass = ! flags.changed
      })
    }
  }

  unwatch?: () => void

  destroyed() {
    console.trace('destroyed');
  }

}
